export const standards = [
    "ISO 9001: 2015",
    "ISO 45001: 2018",
    "ISO 14001: 2015",
    "ISO 9001: 2015 + ISO 45001: 2018",
    "ISO 45001: 2018 + ISO 14001: 2015",
    "ISO 9001: 2015 + ISO 14001: 2015",
    "ISO 9001: 2015 + ISO 45001: 2018 + ISO 14001: 2015",
  ];
  
  export const quarters = [
    {"quarter":"1", "label":"Quarter One: Jan - Mar", },
    {"quarter":"2", "label":"Quarter Two: Apr - May"},
    {"quarter":"3", "label" :"Quarter Three: Jul - Sep"},
    {"quarter":"4", "label" :"Quarter Four: Oct - Dec"},
  ];
  
  export const months = [
    {"month": "January"},
    {"month": "February"},
    {"month": "March"},
    {"month": "April"},
    {"month": "May"},
    {"month": "June"},
    {"month": "July"},
    {"month": "August"},
    {"month": "September"},
    {"month": "October"},
    {"month": "November"},
    {"month": "December"},
  ];
  
  export const ratings = [
    {"rating": "5"},
    {"rating": "4"},
    {"rating": "3"},
    {"rating": "2"},
    {"rating": "1"},
    {"rating": "0"},
  ];
  
  export const weeks = [
    {"label": "53"},
    {"label": "52"},
    {"label": "51"},
    {"label": "50"},
    {"label": "49"},
  ];
  
  export const ratingScales = [
    {"scale": "Exceptional Performance", "score": "5", "def":"Consistently exceeds all relevant performance standards. Provides leadership, fosters teamwork, is highly productive, innovative, responsive and generates top quality work"},
    {"scale": "Exceeds Expectation", "score": "4", "def":"Consistently meets and often exceeds all relevant performance standards. Shows initiative and versatility, works collaboratively, has strong technical and interpersonal skills or has achieved significant improvement in these areas"},
    {"scale": "Meets Expectation", "score": "3", "def":"Meets relevant performance standards. Seldom exceeds or falls short of desired results or objective"},
    {"scale": "Inconsistent Performance", "score": "2", "def":"Sometimes meets the performance standards. Seldom meets and often falls short of desired results. Performance has declined significantly, or employee has not sustained adequate improvement as required "},
    {"scale": "Unacceptable Performance", "score": "1", "def":"Lacks skills and competency required. Performance was consistently below minimum acceptable expectations in most essential areas of responsibility, and reasonable progress towards critical goals were not made"},
  ];
  
  export const states = [
    { value: "abia", label: "Abia" },
    { value: "adamawa", label: "Adamawa" },
    { value: "akwaibom", label: "Akwa Ibom" },
    { value: "anambra", label: "Anambra" },
    { value: "bauchi", label: "Bauchi" },
    { value: "bayelsa", label: "Bayelsa" },
    { value: "benue", label: "Benue" },
    { value: "borno", label: "Borno" },
    { value: "crossriver", label: "Cross River" },
    { value: "delta", label: "Delta" },
    { value: "ebonyi", label: "Ebonyi" },
    { value: "edo", label: "Edo" },
    { value: "ekiti", label: "Ekiti" },
    { value: "enugu", label: "Enugu" },
    { value: "fct", label: "FCT" },
    { value: "gombe", label: "Gombe" },
    { value: "imo", label: "Imo" },
    { value: "jigawa", label: "Jigawa" },
    { value: "kaduna", label: "Kaduna" },
    { value: "kano", label: "Kano" },
    { value: "katsina", label: "Katsina" },
    { value: "kebbi", label: "Kebbi" },
    { value: "kogi", label: "Kogi" },
    { value: "kwara", label: "Kwara" },
    { value: "lagos", label: "Lagos" },
    { value: "nasarawa", label: "Nasarawa" },
    { value: "niger", label: "Niger" },
    { value: "ogun", label: "Ogun" },
    { value: "ondo", label: "Ondo" },
    { value: "osun", label: "Osun" },
    { value: "oyo", label: "Oyo" },
    { value: "plateau", label: "Plateau" },
    { value: "rivers", label: "Rivers" },
    { value: "sokoto", label: "Sokoto" },
    { value: "taraba", label: "Taraba" },
    { value: "yobe", label: "Yobe" },
    { value: "zamfara", label: "Zamfara" },
  ];